import { makeObservable, observable, computed, action, toJS } from 'mobx';
import FilterState from '@features/categories/mobx/state/FilterState';
import { TFilterAbstract } from '@features/categories/typescript';
import { replaceBrowserSearchParams } from '@utils/replaceBrowserSearchParams';
export default class FilterInputState extends FilterState {
  state = '';
  constructor(filter: TFilterAbstract) {
    super(filter);
    makeObservable(this, {
      state: observable,
      queryURLString: computed,
      setValue: action,
      resetValue: action,
      value: computed,
      isSet: computed
    });
    this.state = '';
  }
  get value() {
    return toJS(this.state);
  }
  get isSet() {
    return this.state !== '';
  }
  setValue(value: string, noURLUpdate = false) {
    this.state = value;
    if (!noURLUpdate) {
      this.markUserActivity();
      this.setValueToURLString();
    }
  }
  resetValue(noURLUpdate = false) {
    this.setValue('', noURLUpdate);
  }
  setValueFromURLString() {
    const urlParams = new URLSearchParams(window.location.search);
    const paramValue = urlParams.get(this.queryName);
    if (paramValue) this.state = paramValue;
  }
  setValueToURLString() {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set(this.queryName, this.value);
    replaceBrowserSearchParams(urlParams);
  }
  get queryURLString() {
    const urlParams = new URLSearchParams();
    urlParams.append(this.queryName, this.value);
    return decodeURI(urlParams.toString());
  }
}